module.exports = __webpack_public_path__ + "img/78a37bb.jpg";